window.addEventListener("load", (event) => {
  let element = document.querySelector(".sq-container.sq-app");
  let loader = document.querySelector(".sq-sy-loader");

  if (!element) {
    loader.style.display = "block";
  } else {
    loader.style.display = "none";
  }
});

window.sq = window.sq || {};
window.FloatingUIDOM = window.FloatingUIDOM || {};

window.FloatingUIDOM.setupDropdown = (function () {
  const dropdownInput = document.querySelector(".search-bar__input");
  const dropdownList = document.getElementById("dropdownList");

  const toggleDropdown = function () {

    if(!dropdownList) return;
    
    if (dropdownList?.style.display === "flex") {
      dropdownList.style.display = "none";
    } else {
      dropdownList.style.display = "flex";
    }
  };

  const selectOption = function (option) {
    const selectedOption = option.textContent;
    dropdownInput.value = selectedOption;
    toggleDropdown();
  };

  // Show dropdown list on input box click
  dropdownInput.addEventListener("click", toggleDropdown);
  return {
    selectOption: selectOption,
  };
})();

window.addEventListener("click", function (event) {
  const dropdownInput = document.querySelector(".search-bar__input");
  const dropdownList = document.getElementById("dropdownList");
  
  if (!dropdownList.contains(event.target) && event.target !== dropdownInput) {
    dropdownList.style.display = 'none'; // Hide the dropdown list
  }
  
  if (dropdownInput.contains(event.target)) {
    dropdownList.style.display = 'block'; // Show the dropdown list
  }
});

window.addEventListener("onload",function() {
  const resultsLoading = document.querySelector(".sq-results.sq-loading");
  const resultsButton = documennt.querSelector("a.button.btn-blue");
  if(resultsLoading) {
    resultsButton.style.display = "none"
  }
})

window.sq.dropdownSearch = (store) => {
  store.search({ page: 1, restrictByCollection: false });
};

window.sq.initSearch = (store) => {
  const inStockFilter = document.getElementById("sq-filter-in-stock");
  const outStockFilter = document.getElementById("sq-filter-out-stock");

  store.filter = store.filter.replace("variants.inventory_quantity > 0", "");
  store.filter = store.filter.replace("variants.inventory_quantity = 0", "");

  if (inStockFilter.checked && !outStockFilter.checked) {
    store.filter = store.filter
      ? `${store.filter} AND variants.inventory_quantity > 0`
      : "variants.inventory_quantity > 0";
    history.replaceState(null, null, "?instock=true");
  } else if (!inStockFilter.checked && outStockFilter.checked) {
    store.filter = store.filter
      ? `${store.filter} AND variants.inventory_quantity = 0`
      : "variants.inventory_quantity = 0";
    history.replaceState(null, null, "?instock=false");
  } else {
    history.replaceState(null, null, window.location.pathname);
  }

  store.search();
};

function toggleFilter() {
  let x = document.querySelector(".sq-sidebar.filter");
  x.classList.toggle("opening");
}

function removeClass() {
  let z = document.querySelector(".sq-sidebar.filter");
  z.classList.remove("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-sidebar.filter");
  y.classList.remove("opening");
}

window.sq.sort = () => {
  const valuePickerButton = document.querySelector(
    ".sq-sort.value-picker-button"
  );
  const sortSelector = document.querySelector("#sort-by-selector");

  const isExpanded = valuePickerButton.getAttribute("aria-expanded") === "true";
  valuePickerButton.setAttribute("aria-expanded", !isExpanded);
  sortSelector.setAttribute("aria-hidden", isExpanded);
};

window.sq.perPage = () => {
  const valuePickerButton = document.querySelector(
    "button.sq-per-page.value-picker-button"
  );
  const sortSelector = document.querySelector("#display-by-selector");

  const isExpanded = valuePickerButton.getAttribute("aria-expanded") === "true";
  valuePickerButton.setAttribute("aria-expanded", !isExpanded);
  sortSelector.setAttribute("aria-hidden", isExpanded);
};

window.sq.changeView = () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  gridButton.addEventListener("click", () => {
    productList?.classList.remove("list-view");
    dataGrid.style.display = "flex";
    gridButton?.classList.add("is-selected");
    dataGrid?.classList.remove("sq-list-view");
    listButton?.classList.remove("is-selected");
    window.sq.custom = { isList: false };
  });

  listButton.addEventListener("click", () => {
    productList?.classList.add("list-view");
    dataGrid?.classList.add("sq-list-view");
    gridButton?.classList.remove("is-selected");
    listButton?.classList.add("is-selected");
    window.sq.custom = { isList: true };
  });
};

window.addEventListener("load", () => {
  const gridButton = document.querySelector('[data-layout-mode="grid"]');
  const listButton = document.querySelector('[data-layout-mode="list"]');
  const productList = document.querySelector(".collection__products");
  const dataGrid = document.querySelector(".sq-results");

  gridButton.addEventListener("click", () => {
    productList?.classList.remove("list-view");
    dataGrid.style.display = "flex";
    gridButton?.classList.add("is-selected");
    dataGrid?.classList.remove("sq-list-view");
    listButton?.classList.remove("is-selected");
    window.sq.custom = { isList: false };
  });

  listButton.addEventListener("click", () => {
    productList?.classList.add("list-view");
    dataGrid?.classList.add("sq-list-view");
    gridButton?.classList.remove("is-selected");
    listButton?.classList.add("is-selected");
    window.sq.custom = { isList: true };
  });
});

function appendClass() {
  const appliedFilters = document.querySelectorAll(
    ".sq-filter-item.sq-block.sq-active"
  );
  const clearBtn = document.querySelector(".clear-all");

  if (appliedFilters.length >= 1) {
    clearBtn?.classList.add("added");
  } else {
    clearBtn?.classList.remove("added");
  }
}

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (
      url &&
      url.toLowerCase() ===
        "https://sii2vlcr6p45uhey8gn61qyq.fast.sparq.ai/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);
      body.sort.push("-inventory_quantity")
      body.facetCount = 1000;
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);

(function (XHR) {
  "use strict";

  var open = XHR.prototype.open;
  var send = XHR.prototype.send;

  XHR.prototype.open = function (method, url, async, user, pass) {
    this._url = url;
    open.call(this, method, url, async, user, pass);
  };

  XHR.prototype.send = function (data) {
    var self = this;
    var url = this._url;

    if (
      url &&
      url.toLowerCase() ===
        "https://sii2vlcr6p45uhey8gn61qyq.fast.sparq.ai/v2".toLowerCase()
    ) {
      const body = JSON.parse(data);
      if(body.collection == "8NBBIH5Z73Y2CGQ28QBEE5YF") {
        body.textFacets = [];
      }
      data = JSON.stringify(body);
    }
    send.call(this, data);
  };
})(XMLHttpRequest);
